
export const defaultStudioFolderPC24 = '5406e7a96c6e79e483e71d47'; // web/heavy-tyres/img/product_images/
